import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminPoll() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/poll`, { withCredentials: true });
        setData(res.data);
      } catch (e) { setErr(e?.response?.data?.detail || "Failed to load"); }
    })();
  }, []);

  if (err) return <p className="text-red-600 text-sm">{err}</p>;
  if (!data) return <p className="text-[#0F1F4E]/70">Loading…</p>;

  const total = Math.max(data.total, 1);

  return (
    <section data-testid="admin-poll">
      <h2 className="font-serif text-3xl md:text-4xl font-light mb-2 tracking-tight">
        Facials wait-list poll
      </h2>
      <p className="text-sm text-[#0F1F4E]/70 mb-8">
        {data.total} total vote{data.total === 1 ? "" : "s"} across {data.options.length} options.
      </p>

      <div className="space-y-3 mb-12">
        {data.options.map((opt) => {
          const count = data.counts[opt] || 0;
          const pct = Math.round((count / total) * 100);
          return (
            <div
              key={opt}
              data-testid={`poll-bar-${opt}`}
              className="bg-white border border-[#D9CFA0] rounded-lg p-4"
            >
              <div className="flex items-baseline justify-between mb-2">
                <span className="text-sm">{opt}</span>
                <span className="text-xs uppercase tracking-wider text-[#0F1F4E]/70">
                  {count} ({pct}%)
                </span>
              </div>
              <div className="h-2 bg-[#F2EBD3] rounded-full overflow-hidden">
                <div className="h-full bg-[#EAD584]" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>

      <h3 className="font-serif text-2xl font-light mb-4">Voter emails</h3>
      {data.votes.length === 0 ? (
        <p className="text-[#0F1F4E]/70 text-sm">No voters yet.</p>
      ) : (
        <div className="overflow-x-auto bg-white border border-[#D9CFA0] rounded-lg">
          <table className="min-w-full text-sm">
            <thead className="bg-[#F2EBD3]">
              <tr className="text-left text-xs uppercase tracking-wider text-[#0F1F4E]/70">
                <th className="px-4 py-3">Voted</th>
                <th className="px-4 py-3">Option</th>
                <th className="px-4 py-3">Email</th>
              </tr>
            </thead>
            <tbody>
              {data.votes.map((v) => (
                <tr key={v.id} className="border-t border-[#D9CFA0]/70">
                  <td className="px-4 py-3 whitespace-nowrap">
                    {new Date(v.created_at).toLocaleString("en-US")}
                  </td>
                  <td className="px-4 py-3">{v.option}</td>
                  <td className="px-4 py-3">{v.email || "(anonymous)"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
